import React, { Component } from "react";
import { toast } from "react-toastify";

import HmcTable from "./HmcTable";
import HmcData from "./HmcData";

import { getHmcData } from "../../../actions/biochem";
import "./Biochem.css";

export default class Hmc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showData: false,
      rowIndex: null,
      loading: false,
      disable: false,
    };
  }

  componentDidMount() {
    this.generateHmcData();
  }

  generateHmcData = async () => {
    this.setState({ loading: true });
    const response = await getHmcData();
    let listData = [];
    if (response && response.success) {
      listData = response.List;
    } else if (response.message !== "No Data") {
      toast.error(response.message);
    }
    this.setState({
      data: listData,
      loading: false,
      showData: false,
      rowIndex: null,
    });
  };

  showHmcData = (index) => {
    this.setState({
      showData: true,
      rowIndex: index,
    });
  };

  disableUserInput = (value) => {
    this.setState({ disable: value });
  }

  render() {
    const {
      data, showData, rowIndex, loading, disable,
    } = this.state;
    return (
      <div className="dropzone-wrapper biochemGeneral">
        <HmcTable
          showHmcData={this.showHmcData}
          data={data}
          rowIndex={rowIndex}
          loading={loading}
          disable={disable}

        />
        {showData && (
          <HmcData
            data={data[rowIndex]}
            generateHmcData={this.generateHmcData}
            disableUserInput={this.disableUserInput}
          />
        )}
      </div>
    );
  }
}
